/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { Match, Query } from '@atlassian/react-resource-router';

export const getBoardId = (match: Match, query: Query): string =>
	match.params.boardId || query.rapidView || query['board.id'];
